module.exports = __webpack_public_path__ + "img/cozinhas.d762e58a.webp";